import { TODAY } from '../../constants';
import type { Client, Phase } from '../../types/domain';
import { isoStr } from '../dates';
import { getActivePhase } from './activePhases';

// Rang d'affichage : 0 = phase principale, 1 = en cours, 2 = à venir, 3 = clôturée.
function rank(ph: Phase, activeId: string | undefined, todayIso: string): number {
  if (ph.id === activeId) return 0;
  if (ph.dateDebut && ph.dateDebut > todayIso) return 2;
  if (ph.dateFin && ph.dateFin < todayIso) return 3;
  return 1;
}

/* Ordre des phases dans la fiche projet : phase principale, autres phases en cours, phases à venir
   (par date de début), puis phases clôturées (les plus récentes d'abord). */
export function phasesInDisplayOrder(client: Client): Phase[] {
  const todayIso = isoStr(TODAY);
  const activeId = getActivePhase(client)?.id;
  return [...(client.phases || [])].sort((a, b) => {
    const ra = rank(a, activeId, todayIso);
    const rb = rank(b, activeId, todayIso);
    if (ra !== rb) return ra - rb;
    if (ra === 2) return (a.dateDebut || '').localeCompare(b.dateDebut || '');
    if (ra === 3) return (b.dateFin || '').localeCompare(a.dateFin || '');
    return 0;
  });
}
